import { LocalData } from '../shared/LocalStorage';

export const initialState: LocalData = {	
    isSignedin: false,
    accessToken: '',
    refreshToken: '',
    roles: [],
    permissions: [],
    imageUrl: '',
    name: '',
    activityData: {},
    isSubscribed: false
};

export enum ActionTypes {
    LoginSuccess = 'LoginSuccess',
    LoadFromHook = 'LoadFromHook',
    UpdateImage = 'UpdateImage',
    UpdateKey = 'UpdateKey',
    Logout = 'Logout',
    updateActivityData = 'updateActivityData'
}

interface AuthAction {
    type: ActionTypes;
    payload?: any;
}

export const AuthReducer = (state: LocalData, action: AuthAction): LocalData => {
    switch (action.type) {
        case ActionTypes.LoadFromHook:
            return state;

        case ActionTypes.LoginSuccess:
            return {
                ...state,
                isSignedin: action.payload.isSignedin,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                roles: action.payload.roles,
                permissions: action.payload.permissions,
                imageUrl: action.payload?.imageUrl || '',
                key: action.payload?.key,
                name: action.payload?.name || '',
                isPaymentDue: action.payload?.isPaymentDue,
                isSubscribed: action.payload?.isSubscribed,
            };

        case ActionTypes.UpdateImage:
            return {
                ...state,
                imageUrl: action.payload || ''
            };

        case ActionTypes.UpdateKey:
            return {
                ...state,
                key: action.payload || undefined
            };

        case ActionTypes.Logout:
            return {
                ...initialState
            };

        case ActionTypes.updateActivityData:
            return {
                ...state,
                activityData: action.payload || {}
            };

        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};